import { render, staticRenderFns } from "./pagesHeader.vue?vue&type=template&id=9de273c0&scoped=true&"
import script from "./pagesHeader.vue?vue&type=script&lang=js&"
export * from "./pagesHeader.vue?vue&type=script&lang=js&"
import style0 from "./pagesHeader.vue?vue&type=style&index=0&id=9de273c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de273c0",
  null
  
)

export default component.exports